import { render } from "./PaymentsEdit.vue?vue&type=template&id=cc035c7c&scoped=true"
import script from "./PaymentsEdit.vue?vue&type=script&lang=js"
export * from "./PaymentsEdit.vue?vue&type=script&lang=js"

import "./PaymentsEdit.vue?vue&type=style&index=0&id=cc035c7c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc035c7c"]])

export default __exports__